// models
import {
	NewContractIAImportProcess,
	ContractIAImportProcess,
	ImportFeedbackRatingScaleItem
} from '../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../models/HttpError';

// Create IA import process
export const CONTRACT_IAIMPORT_CREATE_REQUEST = 'CONTRACT_IAIMPORT_CREATE_REQUEST';
export const CONTRACT_IAIMPORT_CREATE_SUCCESS = 'CONTRACT_IAIMPORT_CREATE_SUCCESS';
export const CONTRACT_IAIMPORT_CREATE_FAILURE = 'CONTRACT_IAIMPORT_CREATE_FAILURE';

export interface ContractIAImportCreateRequestAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_REQUEST;
	newProcess: NewContractIAImportProcess;
}

export interface ContractIAImportCreateSuccessAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_SUCCESS;
	process: ContractIAImportProcess;
}

export interface ContractIAImportCreateFailureAction {
	type: typeof CONTRACT_IAIMPORT_CREATE_FAILURE;
	error: ErrorType;
}

// Get last IA import process for a contract
export const CONTRACT_IAIMPORT_GETLAST_REQUEST = 'CONTRACT_IAIMPORT_GETLAST_REQUEST';
export const CONTRACT_IAIMPORT_GETLAST_SUCCESS = 'CONTRACT_IAIMPORT_GETLAST_SUCCESS';
export const CONTRACT_IAIMPORT_GETLAST_FAILURE = 'CONTRACT_IAIMPORT_GETLAST_FAILURE';

export interface ContractIAImportGetLastRequestAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_REQUEST;
	contractId: number;
}

export interface ContractIAImportGetLastSuccessAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_SUCCESS;
	contractId: number;
	process: ContractIAImportProcess | null;
}

export interface ContractIAImportGetLastFailureAction {
	type: typeof CONTRACT_IAIMPORT_GETLAST_FAILURE;
	contractId: number;
	error: ErrorType;
}


// Get IA import history for a contract
export const CONTRACT_IAIMPORT_GETHISTORY_REQUEST = 'CONTRACT_IAIMPORT_GETHISTORY_REQUEST';
export const CONTRACT_IAIMPORT_GETHISTORY_SUCCESS = 'CONTRACT_IAIMPORT_GETHISTORY_SUCCESS';
export const CONTRACT_IAIMPORT_GETHISTORY_FAILURE = 'CONTRACT_IAIMPORT_GETHISTORY_FAILURE';

export interface ContractIAImportGetHistoryRequestAction {
	type: typeof CONTRACT_IAIMPORT_GETHISTORY_REQUEST;
	contractId: number;
}

export interface ContractIAImportGetHistorySuccessAction {
	type: typeof CONTRACT_IAIMPORT_GETHISTORY_SUCCESS;
	contractId: number;
	processes: ContractIAImportProcess[];
}

export interface ContractIAImportGetHistoryFailureAction {
	type: typeof CONTRACT_IAIMPORT_GETHISTORY_FAILURE;
	contractId: number;
	error: ErrorType;
}

// Get the IA import feedback rating scale (catálogo publicado por la API)
export const CONTRACT_IAIMPORT_GETRATINGSCALE_REQUEST = 'CONTRACT_IAIMPORT_GETRATINGSCALE_REQUEST';
export const CONTRACT_IAIMPORT_GETRATINGSCALE_SUCCESS = 'CONTRACT_IAIMPORT_GETRATINGSCALE_SUCCESS';
export const CONTRACT_IAIMPORT_GETRATINGSCALE_FAILURE = 'CONTRACT_IAIMPORT_GETRATINGSCALE_FAILURE';

export interface ContractIAImportGetRatingScaleRequestAction {
	type: typeof CONTRACT_IAIMPORT_GETRATINGSCALE_REQUEST;
}

export interface ContractIAImportGetRatingScaleSuccessAction {
	type: typeof CONTRACT_IAIMPORT_GETRATINGSCALE_SUCCESS;
	scale: ImportFeedbackRatingScaleItem[];
}

export interface ContractIAImportGetRatingScaleFailureAction {
	type: typeof CONTRACT_IAIMPORT_GETRATINGSCALE_FAILURE;
	error: ErrorType;
}

// Rate an IA import process (feedback de única vez, inmutable)
export const CONTRACT_IAIMPORT_RATE_REQUEST = 'CONTRACT_IAIMPORT_RATE_REQUEST';
export const CONTRACT_IAIMPORT_RATE_SUCCESS = 'CONTRACT_IAIMPORT_RATE_SUCCESS';
export const CONTRACT_IAIMPORT_RATE_FAILURE = 'CONTRACT_IAIMPORT_RATE_FAILURE';

export interface ContractIAImportRateRequestAction {
	type: typeof CONTRACT_IAIMPORT_RATE_REQUEST;
	processId: string;
}

export interface ContractIAImportRateSuccessAction {
	type: typeof CONTRACT_IAIMPORT_RATE_SUCCESS;
	processId: string;
	process: ContractIAImportProcess;
}

export interface ContractIAImportRateFailureAction {
	type: typeof CONTRACT_IAIMPORT_RATE_FAILURE;
	processId: string;
	error: ErrorType;
	// Presente sólo en el 409: la calificación ya registrada, tal como la
	// devuelve la API, para reflejarla sin volver a consultar el proceso.
	alreadyRatedProcess?: ContractIAImportProcess;
}
